<template>
    <div>
        <div class="main-query main-area">
            <div class="main-container-area query-area">
                <div class="table-area">
                    <div class="search-area">
                        <el-input v-model="worksName" size="small" placeholder="请输入作品名称" clearable> </el-input> 
                        <el-button type="primary" @click="handleSearch" size="small">查询</el-button>
                    </div>
                </div>
                <div class="table-content">
                    <el-table
                        size="medium"
                        :border="true"
                        :show-overflow-tooltip="true"
                        :header-cell-style="headerStyle"
                        :data="tableData"
                        style="width: 100%"> 
                        <el-table-column
                            prop="worksName"
                            label="作品名称"
                           >
                        </el-table-column>
                        <el-table-column
                            prop="worksType"
                            label="作品类型"
                           >
                           <template slot-scope="scope">
                                <span>{{ loadWorksType(scope.row.worksType)}}</span>
                           </template>
                        </el-table-column>
                        <el-table-column
                            prop="strOwners"
                            label="著作权人"
                           >
                        </el-table-column>
                        <el-table-column
                            prop="cerConfirmTime"
                            label="发证时间"
                            width="200"
                           >
                        </el-table-column>
                        <el-table-column   prop="action"  label="操作"  width="140" >
                            <template slot-scope="scope">
                                <div class="action-cell" @click="handleDownload(scope.row)">
                                    <span style="color:#366EEE">下载证书</span>
                                    <img src="../../assets/images/download.png" alt="">
                                </div>
                                <!-- <div v-if="scope.row.status===-1" class="action-cell" @click="handleSeeReason(scope.row)">
                                    <span style="color:#366EEE">查看原因</span>
                                    <img src="../../assets/images/see.png" alt="">
                                </div> -->
                            </template>
                        </el-table-column>
                        <template slot="empty">
                            <p class="no-data">
                                    <img src="~@/assets/images/no-data.png" alt="">
                            </p>
                        </template> 
                    </el-table>
                </div>
            </div>
        </div>  
        <DownloadModal  ref="download"/>
    </div>
   
</template>

<script>
import DownloadModal from './modal/Download.vue';
import { getCopyrightRegister } from '@/api/business'
    export default {
        name:'Query',
        components:{
            DownloadModal
        },
        data () {
            return {
                serialNumber:'',
                worksName:'',
                tableData:[],
            }
        },
        mounted() {
        },
        methods: {

            fetch(){
                // if(!this.worksName){
                //     this.$message({
                //         message: '作品名称为必填',
                //         type: 'warning',
                //     });
                // }
               getCopyrightRegister({worksName:this.worksName}).then(res=>{
                if(res.code==200){
                    this.tableData = res.result.records;
                }
               })
            },
            loadWorksType(status){
                switch(status){
                    case '1':
                    return '文字作品';
                    case '2':
                    return '口述作品';
                    case '3':
                    return '音乐作品';
                    case '4':
                    return '戏剧作品';
                    case '5':
                    return '曲艺作品';
                    case '6':
                    return '舞蹈作品';
                    case '7':
                    return '杂技作品';
                    case '8':
                    return '美术作品';
                    case '9':
                    return '建筑作品';
                    case '10':
                    return '摄影作品';
                    case '11':
                    return '视听作品';
                    case '12':
                    return '工程设计图、产品设计图';
                    case '13':
                    return '地图、示意图';
                    case '14':
                    return '模型';
                    case '15':
                    return '其他作品';
                    default:
                    return '';
                }
            },
            loadStatusText(status){
                switch(status){
                    case 1:
                        return '审查中';
                    case 2:
                        return '已办结';
                    case -1:
                        return '审查不通过';
                    default:
                        return '审查中';
                }
            },
            loadStatusClass (status){
                switch(status){
                    case 1:
                        return 'blue-icon';
                    case 2:
                        return 'green-icon';
                    case -1:
                        return 'red-icon';
                    default:
                        return 'blue-icon';
                }
            },
            headerStyle({row, column, rowIndex, columnIndex}){
                return {
                    // backgroundColor:'#7D7D7D',
                    backgroundColor:'#eeeeee',
                    color:'#404040',
                    fontSize:'0.16rem',
                    fontWeight:500,
                }
            },
            handleSearch(){
                this.fetch();
                // let newArr = [];
                // if(!this.serialNumber && !this.name){
                //     this.tableData = this.originData;
                //     return
                // }
                // this.tableData.map(item=>{
                //     if(this.serialNumber && this.name && item.serialNumber.match(this.serialNumber) && this.name && item.name.match(this.name)){
                //         newArr.push(item);
                //         return 
                //     }
                //     if( this.serialNumber && item.serialNumber.match(this.serialNumber) != null) {
                //         newArr.push(item);
                //         return
                //     }
                //     if(this.name && item.name.match(this.name) != null){
                //         newArr.push(item);
                //         return
                //     }
                // })
                // this.tableData = newArr;
            },
            handleSeeReason(row){
                this.$refs.reason.showDialog(row);
            },
            handleDownload(row){
                this.$refs.download.showDialog(row);
            }

        },
        computed: {

        },
        watch: {

        }
    }
</script>

<style lang="less" scoped>
.main-query{
    background-color: #EEF0FF;
    box-sizing: border-box;
    width: 1200px;
    margin: 0 auto;
    margin-top: 68px;
    .table-area{
        width:1200px;
        margin:0 auto;
    }
    .query-area{
        padding: 50px 0;
        box-sizing: border-box;
        .search-area{
            display: flex;
            box-sizing: border-box;
            justify-content: space-between;
            /deep/ .el-input{
                width:500px;
                font-size: 16px;
                height:50px;
            }
          /deep/ .el-input__inner{
                height: 40px;
            }
            .el-button{
                // width:2.18rem;
                padding: 0 50px;
                font-size: 16px;
                height: 40px;
                // letter-spacing: .5rem;
            }
        }   
    }
    .no-data{
        text-align: center;
        font-size: 20px;
        margin-top: 50px;
        color: #666;
        img{
            width: 80px;
            
        }
    }
    .table-content{
        margin-top:30px;
        // /deep/.el-table--border .el-table__cell, .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed{
        //     border-right:1px solid #cfcfcf;
        // }
        /deep/ .el-table tr{
            height: 58px;
        }
        /deep/.cell{
            display: flex;
            align-items: center;
            line-height: inherit;
            font-size: 16px;
            white-space: nowrap;
            // color: #404040;
            // font-weight: 500;
        }
        .check-status{
            width:12px;
            height: 12px;
            display: inline-block;
            border-radius: 50%;
            margin-right: 6px;
        }
        .action-cell{
            cursor: pointer;
            // padding-left:.19rem;
            display: flex;
            align-items: center;
            justify-content: center;
            img{
                width: 14px;
                height: 14px;
                margin-left: 10px;
            }
        }
        .blue-icon{
            background-color: #366eee;
        }
        .green-icon{
            background-color: #71ec50;
        }
        .red-icon{
            background-color: #fd5337;
        }
    }
}

 :deep(.el-table__empty-block){
    min-height:350px;
 }
</style>